var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"payoff",class:_vm.$web.isDesktop?'desktop-payoff':'mobile-payoff',domProps:{"textContent":_vm._s('404 - Pagina non trovata')}})])}
var staticRenderFns = []

export { render, staticRenderFns }